import { TableCell, TableRow } from '../table';

const DataTableNoResult = ({ colSpan = 0 }) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} className="h-24 text-center">
        No results.
      </TableCell>
    </TableRow>
  );
};
export default DataTableNoResult;
